var _path, _g, _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRfBattery = function SvgRfBattery(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    width: 16,
    height: 16,
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    fill: "currentColor",
    transform: "translate(0 -1036.4)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path3774",
    d: "M5.5 1036.4v2H3v14l10 .031v-14.03h-2.5v-2zm1.5 2h2v2h2v10H5v-10h2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "text2983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3200",
    d: "M8.581 1047.2H7.336l-.005-.327q0-.606.2-.996t.801-.88q.6-.487.718-.639.18-.24.18-.527 0-.4-.322-.684-.317-.288-.86-.288-.522 0-.873.298-.352.298-.484.908l-1.26-.156q.054-.874.743-1.484.693-.61 1.816-.61 1.182 0 1.88.62.698.615.698 1.435 0 .454-.258.86-.254.405-1.094 1.103-.435.361-.542.58-.103.22-.093.787m-1.245 1.846v-1.372h1.372v1.372z"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text3195",
    x: 21.602,
    y: 1049.04,
    fontFamily: "Arial",
    fontSize: 10,
    fontWeight: "bold",
    letterSpacing: 0,
    style: {
      lineHeight: "125%"
    },
    wordSpacing: 0
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan3197",
    x: 21.602,
    y: 1049.04
  }, "?")))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRfBattery);
export default ForwardRef;